import React, {useRef} from 'react'
import {useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {FilterDisplayContainer} from 'components/FilterDisplayContainer/FilterDisplayContainer'
import {filterMessages} from 'components/Filters/filterMessages'
import {PropertyTypes} from 'components/Filters/PropertyTypes'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {searchParamToFacet} from 'modules/search/constants'
import {getListOfValues} from 'modules/search/selectors'
import {isNil, takeLast} from 'ramda'
import {getFacetLabel} from 'utils/filters'

interface Props {
  isActive?: boolean
}

export const PropertyTypeFilterPopover: React.FC<Props> = ({
  isActive = false
}) => {
  const {formatMessage} = useIntl()
  const listOfValues = useSelector(getListOfValues)

  const facetFilterKeys = useRef([searchParamToFacet.propertyTypes.param])
  const facetFilterKey = facetFilterKeys.current[0]

  const getLabel = getFacetLabel('PropertyType', listOfValues)
  const {
    submitFilters,
    getFilters,
    getAppliedFilters,
    toggleMultiFilter,
    clearFilters,
    resetFilters,
    trackFilterClick,
    setMultiFilters,
    removeMultiFilters
  } = useFiltersForm(facetFilterKeys.current)

  const facetFilter = getFilters()[facetFilterKey]
  const appliedFacetFilter = getAppliedFilters()[facetFilterKey]
  const labelMessage = formatMessage(filterMessages.propertyType)
  const buildFacetsLabel = React.useCallback((): string => {
    if (isNil(appliedFacetFilter) || isNil(listOfValues)) {
      return labelMessage
    }

    if (appliedFacetFilter.length === 1) {
      return getLabel(appliedFacetFilter[0])
    }

    return `${getLabel(takeLast(1, appliedFacetFilter).toString())} +${
      appliedFacetFilter.length - 1
    }`
  }, [getLabel, appliedFacetFilter, listOfValues, labelMessage])

  return (
    <FilterDisplayContainer
      label={buildFacetsLabel() as React.ReactNode}
      dataId="propertyTypeFilter"
      title={labelMessage}
      isActive={isActive}
      onClear={clearFilters}
      onApply={submitFilters}
      onClose={resetFilters}
      onPillClick={trackFilterClick}
      paddingBottom="s000"
    >
      <PropertyTypes
        isPopover
        filters={facetFilter}
        appliedFilters={appliedFacetFilter}
        setMultiFilters={setMultiFilters}
        removeMultiFilters={removeMultiFilters}
        toggleMultiFilter={toggleMultiFilter}
      />
    </FilterDisplayContainer>
  )
}
